module.exports = "/images/poster.svg?c4732f0ed735a2ff5d4b17a7dddb72fd";